import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { APP_CONFIG } from '../config/appConfig';

export const TermsPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div>
        <h1 className="text-3xl sm:text-4xl font-black text-navy-950">
          Terms of Service & Emergency Disclaimer
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Effective Date: October 2026 • Version 1.0
        </p>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-6 sm:p-8 space-y-6 text-sm text-slate-700 leading-relaxed shadow-xs">
        <section className="p-4 bg-amber-50 border border-amber-300 rounded-xl space-y-2 text-amber-950">
          <div className="flex items-center gap-2 font-bold text-base text-amber-900">
            <ShieldAlert className="w-5 h-5 text-amber-600 flex-shrink-0" />
            <span>CRITICAL PUBLIC SAFETY DISCLAIMER</span>
          </div>
          <p className="text-xs sm:text-sm leading-relaxed">
            SignalNear is an automated third-party public discovery dashboard that ingests open data from the National Weather Service. 
            <strong> SignalNear is NOT a primary life-safety notification system, dispatch console, or governmental emergency response authority.</strong>
          </p>
          <p className="text-xs sm:text-sm font-semibold">
            In the event of an imminent threat to life, health, or property, NEVER rely on SignalNear as your sole source of information. Tune to NOAA Weather Radio, monitor local television and radio broadcasts, or dial 911.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing or using SignalNear ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not access or use the Service.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950">
            2. "As-Is" and "As-Available" Provision
          </h2>
          <p>
            The Service and all meteorological content, maps, and timestamps are provided on an "as-is" and "as-available" basis without warranties of any kind, whether express, statutory, or implied. SignalNear does not warrant that the Service will be uninterrupted, error-free, completely timely, or that upstream data feeds from weather.gov will be continuously accessible.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950">
            3. Limitation of Liability
          </h2>
          <p>
            To the maximum extent permitted by applicable law, SignalNear, its creators, operators, and affiliates shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Service, including but not limited to reliance on any alert, advisory, map geometry, or timestamp published on the website.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-lg font-bold text-navy-950">
            4. Public Domain Data Attribution
          </h2>
          <p>
            Weather warnings, watches, and advisories displayed on SignalNear originate from public domain broadcasts published by the National Weather Service (NWS) and National Oceanic and Atmospheric Administration (NOAA). OpenStreetMap map tiles are used under the Open Database License.
          </p>
        </section>
      </div>
    </div>
  );
};

